@if (isSelecting()) {
  <div>
    <rask-validation-message-row
      type="info"
      message="Tryck och håll nere vänster musknapp för att markera {{geotypes}}.">
    </rask-validation-message-row>
    <div class="right action">
      <rask-button color="tertiary" (click)="stopSelect()">Avbryt
      </rask-button>
    </div>
  </div>
}